import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=36d2bb5d&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/usr/src/motec/components/PageHeader.vue').default,ShowcasesChosenCategoryCard: require('/usr/src/motec/components/showcases/ChosenCategoryCard.vue').default,ProductsChosenCategoryCard: require('/usr/src/motec/components/products/ChosenCategoryCard.vue').default,Spinner: require('/usr/src/motec/components/Spinner.vue').default,Error: require('/usr/src/motec/components/Error.vue').default})
